import { Link } from "@tanstack/react-router";
import { ArrowRight, ClipboardCheck, Sparkles } from "lucide-react";

type Props = {
  eyebrow?: string;
  headline?: string;
  subcopy?: string;
  ctaLabel?: string;
};

export function FreeAuditCTABanner({
  eyebrow = "Free Digital Audit",
  headline = "Get your free digital audit",
  subcopy = "We'll review your site, Google Business Profile, and top 3 competitors — no sales pitch, no credit card.",
  ctaLabel = "Claim my free audit",
}: Props) {
  return (
    <section className="bg-background py-14 lg:py-16">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <div className="flex flex-col gap-6 rounded-2xl border border-brand-gold/30 bg-brand-black p-8 shadow-card lg:flex-row lg:items-center lg:justify-between lg:p-10">
          <div className="max-w-2xl">
            <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold">
              <Sparkles className="h-4 w-4" /> {eyebrow}
            </p>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
              {headline}
            </h2>
            <p className="mt-3 text-base leading-relaxed text-white/75">
              {subcopy}
            </p>
          </div>
          <div className="flex flex-wrap gap-3 lg:flex-shrink-0">
            <Link
              to="/free-audit"
              className="inline-flex items-center gap-2 rounded-md bg-gradient-gold px-5 py-3 text-sm font-bold text-brand-black shadow-gold transition-spring hover:-translate-y-0.5"
            >
              <ClipboardCheck className="h-4 w-4" /> {ctaLabel} <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-md border-2 border-white/25 bg-transparent px-5 py-3 text-sm font-bold text-white transition-smooth hover:border-brand-gold/60 hover:text-brand-gold"
            >
              Talk to a strategist
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
